import Payments from '../../../../store/billing/payments/index';

angular
    .module('festzelt-os.billing.invoices')
    .factory('Payments', [
        '$injector',
        'Payment',
        ($injector, Payment) => new Payments(Payment, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/store/payments.js